// (() => {
//   const drawer = document.getElementById("CartDrawer545");
//   if (!drawer) return;

//   const body = document.body;
//   const openers = () => document.querySelectorAll("#cart-icon-bubble, [data-cart-545-open]");
//   let addOpenTimer = null;

//   const lock = () => body.classList.add("cart-545--open");
//   const unlock = () => body.classList.remove("cart-545--open");
//   const renderRecentlyViewed = () => {
//     window.FIVEFOURFIVE_RECENTLY_VIEWED?.render(drawer);
//   };
//   const updateHeaderCartCount = (count) => {
//     const normalizedCount = Number.isFinite(Number(count)) ? Number(count) : 0;
//     document.querySelectorAll(".header__cart-count-inline").forEach((el) => {
//       el.textContent = `(${normalizedCount})`;
//     });
//   };
//   const refreshHeaderCartCount = async () => {
//     try {
//       const res = await fetch("/cart.js", {
//         credentials: "same-origin",
//         cache: "no-store"
//       });
//       if (!res.ok) return;
//       const cart = await res.json();
//       updateHeaderCartCount(cart.item_count);
//     } catch (e) {
//       // no-op
//     }
//   };
//   const animateProgressBars = () => {
//     drawer.querySelectorAll("[data-progress-target]").forEach((bar) => {
//       const target = Math.max(0, Math.min(100, Number(bar.getAttribute("data-progress-target")) || 0));
//       const key = bar.closest(".cart-545__progress-item")?.classList.contains("cart-545__progress-item--shipping")
//         ? "shipping"
//         : "gift";
//       const previous = Number(drawer.dataset[`progress${key === "shipping" ? "Shipping" : "Gift"}`]);

//       if (Number.isFinite(previous)) {
//         bar.style.width = `${Math.max(0, Math.min(100, previous))}%`;
//         requestAnimationFrame(() => {
//           requestAnimationFrame(() => {
//             bar.style.width = `${target}%`;
//           });
//         });
//       } else {
//         bar.style.width = `${target}%`;
//       }

//       drawer.dataset[`progress${key === "shipping" ? "Shipping" : "Gift"}`] = String(target);
//     });
//   };

//   const open = () => {
//     drawer.setAttribute("aria-hidden", "false");
//     renderRecentlyViewed();
//     animateProgressBars();
//     lock();
//   };

//   const close = () => {
//     drawer.setAttribute("aria-hidden", "true");
//     unlock();
//   };

//   const replaceDrawer = (html) => {
//     const parser = new DOMParser();
//     const doc = parser.parseFromString(html, "text/html");
//     const fresh = doc.querySelector("#CartDrawer545");
//     if (!fresh) return;
//     drawer.innerHTML = fresh.innerHTML;
//     renderRecentlyViewed();
//     animateProgressBars();
//   };

//   const refresh = async () => {
//     try {
//       const res = await fetch("/?sections=cart-drawer-545", {
//         credentials: "same-origin",
//         cache: "no-store"
//       });
//       const data = await res.json();
//       if (data["cart-drawer-545"]) {
//         replaceDrawer(data["cart-drawer-545"]);
//       }
//       await refreshHeaderCartCount();
//     } catch (e) {
//       // no-op
//     }
//   };

//   const changeLine = async (line, quantity) => {
//     try {
//       await fetch("/cart/change.js", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         credentials: "same-origin",
//         body: JSON.stringify({ line, quantity })
//       });
//       await refreshHeaderCartCount();
//       await refresh();
//       open();
//     } catch (e) {
//       // no-op
//     }
//   };

//   document.addEventListener("click", (event) => {
//     const opener = event.target.closest("#cart-icon-bubble, [data-cart-545-open]");
//     if (opener) {
//       event.preventDefault();
//       event.stopPropagation();
//       refresh().then(open);
//       return;
//     }

//     if (event.target.closest("[data-cart-545-close]")) {
//       event.preventDefault();
//       close();
//       return;
//     }

//     const qtyBtn = event.target.closest("[data-cart-545-qty]");
//     if (qtyBtn) {
//       event.preventDefault();
//       const item = qtyBtn.closest(".cart-545__item");
//       const delta = Number(qtyBtn.getAttribute("data-cart-545-qty"));
//       const currentQty = Number(item.querySelector(".cart-545__qty-value")?.textContent || 1);
//       const line = Number(item.getAttribute("data-line"));
//       const nextQty = Math.max(0, currentQty + delta);
//       changeLine(line, nextQty);
//       return;
//     }

//     const removeBtn = event.target.closest("[data-cart-545-remove]");
//     if (removeBtn) {
//       event.preventDefault();
//       const item = removeBtn.closest(".cart-545__item");
//       const line = Number(item.getAttribute("data-line"));
//       changeLine(line, 0);
//       return;
//     }

//     const recentAddBtn = event.target.closest("[data-cart-545-recent-add]");
//     if (recentAddBtn) {
//       event.preventDefault();
//       const variantId = Number(recentAddBtn.getAttribute("data-variant-id"));
//       if (!variantId) return;
//       fetch("/cart/add.js", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         credentials: "same-origin",
//         body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
//       }).then(() => refreshHeaderCartCount()).then(() => refresh()).then(open).catch(() => {});
//     }
//   });

//   const overlay = drawer.querySelector(".cart-545__overlay");
//   overlay?.addEventListener("click", (event) => {
//     event.preventDefault();
//     close();
//   });

//   document.addEventListener("keydown", (event) => {
//     if (event.key === "Escape" && drawer.getAttribute("aria-hidden") === "false") {
//       close();
//     }
//   });

//   openers().forEach((el) => {
//     el.addEventListener("click", (event) => {
//       event.preventDefault();
//       event.stopPropagation();
//       refresh().then(open);
//     });
//   });

//   const scheduleOpenAfterAdd = () => {
//     if (addOpenTimer) window.clearTimeout(addOpenTimer);
//     addOpenTimer = window.setTimeout(() => {
//       refreshHeaderCartCount().then(refresh).then(open);
//     }, 80);
//   };
//   const scheduleOpenAfterSubmit = () => {
//     window.setTimeout(() => {
//       refreshHeaderCartCount().then(refresh).then(open);
//     }, 260);
//     window.setTimeout(() => {
//       refreshHeaderCartCount().then(refresh).then(open);
//     }, 720);
//   };

//   const nativeFetch = window.fetch.bind(window);
//   window.fetch = async (...args) => {
//     const response = await nativeFetch(...args);
//     try {
//       const requestUrl = typeof args[0] === "string" ? args[0] : args[0]?.url;
//       const absoluteUrl = requestUrl ? new URL(requestUrl, window.location.origin) : null;
//       if (absoluteUrl && /\/cart\/add(\.js)?$/.test(absoluteUrl.pathname) && response.ok) {
//         scheduleOpenAfterAdd();
//       }
//       if (absoluteUrl && /\/cart\/(change|update)(\.js)?$/.test(absoluteUrl.pathname) && response.ok) {
//         refreshHeaderCartCount();
//       }
//     } catch (e) {
//       // no-op
//     }
//     return response;
//   };

//   document.addEventListener("fivefourfive:cart-added", () => {
//     scheduleOpenAfterAdd();
//   });

//   document.addEventListener("submit", (event) => {
//     const form = event.target;
//     if (!(form instanceof HTMLFormElement)) return;
//     if (!form.matches('form[data-type="add-to-cart-form"], form[action*="/cart/add"]')) return;
//     scheduleOpenAfterSubmit();
//   }, true);

//   document.addEventListener("click", (event) => {
//     const button = event.target.closest('.product-form__submit[name="add"], #kowi-sticky-atc-btn[name="add"], button[name="add"]');
//     if (!button) return;
//     if (button.hasAttribute("disabled") || button.getAttribute("aria-disabled") === "true") return;

//     const form = button.closest('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
//     if (!form) return;

//     scheduleOpenAfterSubmit();
//   }, true);

//   window.FIVEFOURFIVE_CART_DRAWER = { open, close, refresh };
//   refreshHeaderCartCount();
//   renderRecentlyViewed();
//   animateProgressBars();
// })();

(() => {
  const drawer = document.getElementById("CartDrawer545");
  if (!drawer) return;

  const body = document.body;
  const openers = () => document.querySelectorAll("#cart-icon-bubble, [data-cart-545-open]");
  const themeColorMeta = document.querySelector('meta[name="theme-color"]');
  const initialThemeColor = themeColorMeta?.getAttribute("content") || "";
  const nativeFetch = window.fetch.bind(window);
  const freeGiftVariantId = 43262637113437;
  const freeGiftThreshold = 35000;
  const freeGiftPropertyName = "_free_gift_545";
  const freeGiftPropertyValue = "300-threshold";
  let addOpenTimer = null;
  let freeGiftSyncTimer = null;
  let freeGiftSyncInFlight = false;
  let freeGiftSyncQueued = false;

  const lock = () => body.classList.add("cart-545--open");
  const unlock = () => body.classList.remove("cart-545--open");
  const setSafariChromeColor = () => {
    themeColorMeta?.setAttribute("content", "#ffffff");
  };
  const restoreSafariChromeColor = () => {
    if (!themeColorMeta) return;
    themeColorMeta.setAttribute("content", initialThemeColor);
  };
  const syncViewportHeight = () => {
    const viewportHeight = window.visualViewport?.height || window.innerHeight;
    if (!viewportHeight) return;
    drawer.style.setProperty("--cart-545-viewport-height", `${viewportHeight}px`);
  };
  const renderRecentlyViewed = () => {
    window.FIVEFOURFIVE_RECENTLY_VIEWED?.render(drawer);
  };
  const updateHeaderCartCount = (count) => {
    const normalizedCount = Number.isFinite(Number(count)) ? Number(count) : 0;
    document.querySelectorAll(".header__cart-count-inline").forEach((el) => {
      el.textContent = `(${normalizedCount})`;
    });
  };
  const refreshHeaderCartCount = async () => {
    try {
      const res = await fetch("/cart.js", {
        credentials: "same-origin",
        cache: "no-store"
      });
      if (!res.ok) return;
      const cart = await res.json();
      updateHeaderCartCount(cart.item_count);
    } catch (e) {
      // no-op
    }
  };
  const animateProgressBars = () => {
    drawer.querySelectorAll("[data-progress-target]").forEach((bar) => {
      const target = Math.max(0, Math.min(100, Number(bar.getAttribute("data-progress-target")) || 0));
      const key = bar.closest(".cart-545__progress-item")?.classList.contains("cart-545__progress-item--shipping")
        ? "shipping"
        : "gift";
      const previous = Number(drawer.dataset[`progress${key === "shipping" ? "Shipping" : "Gift"}`]);

      if (Number.isFinite(previous)) {
        bar.style.width = `${Math.max(0, Math.min(100, previous))}%`;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            bar.style.width = `${target}%`;
          });
        });
      } else {
        bar.style.width = `${target}%`;
      }

      drawer.dataset[`progress${key === "shipping" ? "Shipping" : "Gift"}`] = String(target);
    });
  };

  const open = () => {
    syncViewportHeight();
    setSafariChromeColor();
    drawer.setAttribute("aria-hidden", "false");
    scheduleFreeGiftSync();
    renderRecentlyViewed();
    animateProgressBars();
    lock();
  };

  const close = () => {
    drawer.setAttribute("aria-hidden", "true");
    restoreSafariChromeColor();
    unlock();
  };

  const replaceDrawer = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const fresh = doc.querySelector("#CartDrawer545");
    if (!fresh) return;
    drawer.innerHTML = fresh.innerHTML;
    renderRecentlyViewed();
    animateProgressBars();
  };

  const refresh = async () => {
    try {
      const res = await fetch("/?sections=cart-drawer-545", {
        credentials: "same-origin",
        cache: "no-store"
      });
      const data = await res.json();
      if (data["cart-drawer-545"]) {
        replaceDrawer(data["cart-drawer-545"]);
      }
      await refreshHeaderCartCount();
    } catch (e) {
      // no-op
    }
  };

  const changeLine = async (line, quantity) => {
    try {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ line, quantity })
      });
      await refreshHeaderCartCount();
      await refresh();
      open();
    } catch (e) {
      // no-op
    }
  };

  document.addEventListener("click", (event) => {
    const opener = event.target.closest("#cart-icon-bubble, [data-cart-545-open]");
    if (opener) {
      event.preventDefault();
      event.stopPropagation();
      refresh().then(open);
      return;
    }

    if (event.target.closest("[data-cart-545-close]")) {
      event.preventDefault();
      close();
      return;
    }

    const qtyBtn = event.target.closest("[data-cart-545-qty]");
    if (qtyBtn) {
      event.preventDefault();
      const item = qtyBtn.closest(".cart-545__item");
      const delta = Number(qtyBtn.getAttribute("data-cart-545-qty"));
      const currentQty = Number(item.querySelector(".cart-545__qty-value")?.textContent || 1);
      const line = Number(item.getAttribute("data-line"));
      const nextQty = Math.max(0, currentQty + delta);
      changeLine(line, nextQty);
      return;
    }

    const removeBtn = event.target.closest("[data-cart-545-remove]");
    if (removeBtn) {
      event.preventDefault();
      const item = removeBtn.closest(".cart-545__item");
      const line = Number(item.getAttribute("data-line"));
      changeLine(line, 0);
      return;
    }

    const upsellAddBtn = event.target.closest("[data-cart-545-upsell-add], [data-cart-545-recent-add]");
    if (upsellAddBtn) {
      event.preventDefault();
      const variantId = Number(upsellAddBtn.getAttribute("data-variant-id"));
      if (!variantId) return;
      upsellAddBtn.disabled = true;
      upsellAddBtn.setAttribute("aria-busy", "true");
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then((response) => {
          if (!response.ok) throw new Error("Unable to add upsell product");
          return response.json().catch(() => null);
        })
        .then(() => refreshHeaderCartCount())
        .then(() => refresh())
        .then(open)
        .catch(() => {})
        .finally(() => {
          if (!upsellAddBtn.isConnected) return;
          upsellAddBtn.disabled = false;
          upsellAddBtn.removeAttribute("aria-busy");
        });
    }
  });

  const overlay = drawer.querySelector(".cart-545__overlay");
  overlay?.addEventListener("click", (event) => {
    event.preventDefault();
    close();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && drawer.getAttribute("aria-hidden") === "false") {
      close();
    }
  });

  window.addEventListener("resize", syncViewportHeight, { passive: true });
  window.addEventListener("orientationchange", syncViewportHeight);
  window.visualViewport?.addEventListener("resize", syncViewportHeight, { passive: true });
  window.visualViewport?.addEventListener("scroll", syncViewportHeight, { passive: true });

  openers().forEach((el) => {
    el.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      refresh().then(open);
    });
  });

  const scheduleOpenAfterAdd = () => {
    if (addOpenTimer) window.clearTimeout(addOpenTimer);
    addOpenTimer = window.setTimeout(() => {
      refreshHeaderCartCount().then(refresh).then(open);
    }, 80);
  };
  const scheduleOpenAfterSubmit = () => {
    window.setTimeout(() => {
      refreshHeaderCartCount().then(refresh).then(open);
    }, 260);
    window.setTimeout(() => {
      refreshHeaderCartCount().then(refresh).then(open);
    }, 720);
  };

  const isFreeGiftItem = (item) => {
    return Number(item?.variant_id) === freeGiftVariantId
      && item?.properties
      && item.properties[freeGiftPropertyName] === freeGiftPropertyValue;
  };

  const getCart = async () => {
    const res = await nativeFetch("/cart.js", {
      credentials: "same-origin",
      cache: "no-store"
    });
    if (!res.ok) throw new Error("Unable to fetch cart");
    return res.json();
  };

  const getGiftEligibleSubtotal = (cart) => {
    return (cart?.items || []).reduce((total, item) => {
      if (isFreeGiftItem(item)) return total;
      return total + (Number(item.final_line_price) || 0);
    }, 0);
  };

  const changeCartItemByKey = async (key, quantity) => {
    if (!key) return;
    const res = await nativeFetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: key, quantity })
    });
    if (!res.ok) throw new Error("Unable to update free gift");
  };

  const refreshCartSurfacesAfterGiftChange = async () => {
    await refreshHeaderCartCount();
    await refresh();

    if (document.body.classList.contains("template-cart")) {
      window.location.reload();
    }
  };

  const syncFreeGift = async () => {
    if (freeGiftSyncInFlight) {
      freeGiftSyncQueued = true;
      return;
    }

    freeGiftSyncInFlight = true;
    let changed = false;

    try {
      const cart = await getCart();
      const giftItems = (cart.items || []).filter(isFreeGiftItem);
      const isEligible = getGiftEligibleSubtotal(cart) >= freeGiftThreshold;

      if (isEligible && giftItems.length) {
        const [primaryGift, ...extraGifts] = giftItems;
        if (primaryGift.quantity !== 1) {
          await changeCartItemByKey(primaryGift.key, 1);
          changed = true;
        }

        for (const giftItem of extraGifts) {
          await changeCartItemByKey(giftItem.key, 0);
          changed = true;
        }
      } else if (giftItems.length) {
        for (const giftItem of giftItems) {
          await changeCartItemByKey(giftItem.key, 0);
          changed = true;
        }
      }
    } catch (e) {
      // no-op
    } finally {
      freeGiftSyncInFlight = false;
    }

    if (changed) {
      await refreshCartSurfacesAfterGiftChange();
    }

    if (freeGiftSyncQueued) {
      freeGiftSyncQueued = false;
      scheduleFreeGiftSync();
    }
  };

  const scheduleFreeGiftSync = () => {
    if (freeGiftSyncTimer) window.clearTimeout(freeGiftSyncTimer);
    freeGiftSyncTimer = window.setTimeout(syncFreeGift, 120);
  };

  window.fetch = async (...args) => {
    const response = await nativeFetch(...args);
    try {
      const requestUrl = typeof args[0] === "string" ? args[0] : args[0]?.url;
      const absoluteUrl = requestUrl ? new URL(requestUrl, window.location.origin) : null;
      if (absoluteUrl && /\/cart\/add(\.js)?$/.test(absoluteUrl.pathname) && response.ok) {
        scheduleFreeGiftSync();
        scheduleOpenAfterAdd();
      }
      if (absoluteUrl && /\/cart\/(change|update)(\.js)?$/.test(absoluteUrl.pathname) && response.ok) {
        scheduleFreeGiftSync();
        refreshHeaderCartCount();
      }
    } catch (e) {
      // no-op
    }
    return response;
  };

  document.addEventListener("fivefourfive:cart-added", () => {
    scheduleOpenAfterAdd();
  });

  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('form[data-type="add-to-cart-form"], form[action*="/cart/add"]')) return;
    scheduleOpenAfterSubmit();
  }, true);

  document.addEventListener("click", (event) => {
    const button = event.target.closest('.product-form__submit[name="add"], #kowi-sticky-atc-btn[name="add"], button[name="add"]');
    if (!button) return;
    if (button.hasAttribute("disabled") || button.getAttribute("aria-disabled") === "true") return;

    const form = button.closest('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
    if (!form) return;

    scheduleOpenAfterSubmit();
  }, true);

  window.FIVEFOURFIVE_CART_DRAWER = { open, close, refresh };
  syncViewportHeight();
  scheduleFreeGiftSync();
  refreshHeaderCartCount();
  renderRecentlyViewed();
  animateProgressBars();
})();
